const endpoint =
  'https://w2y9bla2q2.execute-api.us-east-1.amazonaws.com/prod/permissions';
export default endpoint;
